module.exports = __webpack_public_path__ + "static/media/monj1.7f0beba3.png";